<template>
    <div>
        <tsoft-table
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :isNeedCreate="isNeedCreate"
            :additionalGetParameter="additionalGetParameter"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            :customAddButtonName="'Добавить'"
        />

        <tsoft-create-driver
            :isSideBarOpenDriver.sync='isSideBarOpenDriver'
            :editIndex.sync="editIndex"
            :editedItemExt.sync="editedItem"
            @create='setCreatedDriver'
            @update='setUpdatedDriver'
            @closeSidePanel='setClosedSidePanelDriver'
        />

        <b-sidebar
            v-if="isSidebarOpenDetail"
            v-model="isSidebarOpenDetail"
            id="sidebar-right"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            no-close-on-backdrop
        >
            <template #title>
                <div class="title-sidebar">
                    <strong class="ml-4">Детальная информация</strong>
                </div>
            </template>
            <div class="d-block">
                <div class="row">
                    <div class="col-md-2">
                        <ul class="parent_item_block d-none d-sm-block nav fa-ul">
                            <li class="parent_item nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#company-details"><span class="fa-li"><i class="fas fa-chevron-right"></i></span> Детали</a>
                            </li>
                            <li class="parent_item nav-item">
                                <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#company-change-history"
                                @click="changeLoad = !changeLoad"
                                >
                                <span class="fa-li"><i class="fas fa-chevron-right"></i></span>
                                    История
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-10">
                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="company-details">
                                <tsoft-driver-details
                                    :itemId="detailedItem.id"
                                />
                            </div>
                            <div class="tab-pane fade" id="company-change-history">
                                <h5 class="mb-4">История изменений водителя <span class="text-secondary">{{detailedItem.name}}</span> (#{{detailedItem.id}})</h5>
                                <tsoft-change-history
                                    :changeHistoryId.sync="detailedItem.id"
                                    :changeModel.sync="model_name"
                                    :changeLoad.sync="changeLoad"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    import { API_DRIVERS } from "../constants"
    import tsoftCreateDriver from "../components/drivers/CreatedOrEditedDriver.vue"
    import tsoftChangeHistory from '../components/logs/ChangeHistory.vue'
    import tsoftDriverDetails from '../components/drivers/DriverDetails.vue'

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
    } from '../mixins'
    import { mixinDocuments } from '../mixins/mixinDocuments'

    const initialEditedItem = () => ({
        'id': '',
        'creator_user_id': '',
        'name': '',
        'passport_number': '',
        'passport_file_photo_id': '',
        'passport_file_address_id': '',
        'passport_issued_by': '',
        'passport_issued_date': '',
        'passport_birth_date': '',
        'passport_birth_town': '',
        'passport_address': '',
        'passport_checked_id': 443,
        'driver_card_number': '',
        'driver_card_file_face_id': '',
        'driver_card_file_back_id': '',
        'driver_card_ends_at': '',
        'driver_card_checked_id': 443,
        'phone': '',
        'phone_additional': '',
        'creator': {},
        'companies': [],
        'passport_checked': {},
        'passport_file_photo': null,
        'passport_file_address': null,
        'driver_card_file_face': null,
        'driver_card_file_back': null,
        'new_passport_file_photo': null,
        'new_passport_file_address': null,
        'new_driver_card_file_face': null,
        'new_driver_card_file_back': null,
    })

    export default {
        props: {
            isNeedCreate: { type: Boolean, required: false, default: true },    // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &company_id=10
            // typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
        },
        components: {
            "tsoft-create-driver": tsoftCreateDriver,
            'tsoft-change-history': tsoftChangeHistory,
            'tsoft-driver-details': tsoftDriverDetails,
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            mixinDocuments
        ],
          data() {
            return {
                model_name: ['App\\Models\\Driver'],
                changeLoad: false,
                isSideBarOpenDriver: false,
                isSideBarOpenPaymentDetails: false,
                tableApiUrl: API_DRIVERS,
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
        },
        methods: {
            onCloseSidePanelLoadingDocument(value) {
                if(value == true){
                    this.checkedLoadDocument = false
                }
            },
            // calls from mixin on show sidebar company
            onOpenCompanyModalCallback() {
                this.isSideBarOpenDriver = true
            },
            setCreatedDriver(data) {
                this.items.data.unshift(data)
                this.editedItem = initialEditedItem()
            },
            setUpdatedDriver(data) {
                Object.assign(this.items.data[this.editIndex], data)
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setClosedSidePanelDriver(){
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
        }
    }
</script>
